export enum EnumPermissionTypeNone {
    read = 0,
    edit = 1,
    view = 2,
    organize = 3,
    none = 4,
    commonUser = 5
}
